import { apply } from "core/utils";
import useOnce from "hooks/use-once";
import { useState } from "react";
import { createModal, displayError } from "../../../../../core/utils/modals";
import { buscarPagosRealizados as apiBuscarPagosRealizados, descargarComprobante as apiDescargarComprobante, obtenerComprobante as apiObtenerComprobante } from "../../api/pagos.api";
import ComprobantePagoModal from "../../components/comprobante-pago.modal";
import PagosRealizadosTable from "../../components/pagos-realizados.table";
import { DatosComprobante, PagoRealizadoRespuesta } from "../../types/pagos.types";

const desplegarComprobante = (descargarComprobante: VoidFunction) => (comprobante?: DatosComprobante) =>
	createModal(ComprobantePagoModal, { datos: comprobante, descargarComprobante });

const usePagosRealizados = () => {
	const [registros, setRegistros] = useState<PagoRealizadoRespuesta[]>([]);
	const [cargandoDatos, setCargandoDatos] = useState(false);

	const buscarPagos = () => {
		setCargandoDatos(true);
		setRegistros([]);

		apiBuscarPagosRealizados()
			.then(setRegistros)
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	const verComprobante = (registro: PagoRealizadoRespuesta) => {
		setCargandoDatos(true);

		apiObtenerComprobante(registro.identificador)
			.then(desplegarComprobante(apply(descargarComprobante, registro)))
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	const descargarComprobante = (registro: PagoRealizadoRespuesta) => {
		setCargandoDatos(true);

		apiDescargarComprobante(registro.identificador)
			.catch(displayError)
			.finally(apply(setCargandoDatos, false));
	};

	useOnce(() => {
		buscarPagos();
	});

	return {
		cargandoDatos,
		registros,
		verComprobante
	};
};

const PagosRealizadosView = () => {
	const {
		cargandoDatos,
		registros,
		verComprobante
	} = usePagosRealizados();

	return (
		<PagosRealizadosTable
			loading={cargandoDatos}
			verComprobante={verComprobante}
			registros={registros}
		/>
	);
};

export default PagosRealizadosView;